import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
// Styles
import { useTheme } from "@mui/material/styles";
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import { Box, useMediaQuery, Container } from "@mui/material";
// Assets
import { LogoItalmundo, ItalmundoFin, ItalmundoFinMobile } from "assets";
import {
  secondaryColor,
  btnPrincipalColor,
} from "assets/jss/material-react.js";

function TarjetaPreAprobada() {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Container
        maxWidth="md"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
          minHeight: "100vh",
          paddingBottom: mobile ? "8rem" : "4rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "0.2rem",
            width: "90%",
          }}
        >
          <img
            src={mobile ? ItalmundoFinMobile : ItalmundoFin}
            alt="Tarjeta"
            style={{
              maxWidth: mobile ? "100%" : "550px",
              objectFit: "contain",
              marginTop: "1rem",
            }}
          />

          <p
            style={{
              textAlign: "center",
              marginTop: "1rem",
              fontSize: mobile ? "40px" : "50px",
              fontWeight: 600,
              maxWidth: "600px",
              color: btnPrincipalColor,
            }}
          >
            ¡Muchas Gracias!
          </p>

          <p
            style={{
              textAlign: "center",
              marginTop: "2rem",
              fontSize: mobile ? "13px" : "15px",
              fontWeight: 500,
              maxWidth: "600px",
              color: secondaryColor,
            }}
          >
            Tu tarjeta fue coordinada con éxito
          </p>

          <p
            style={{
              textAlign: "center",
              marginTop: mobile ? "0.1rem" : "0.5rem",
              fontSize: mobile ? "13px" : "15px",
              fontWeight: 500,
              maxWidth: mobile ? "350px" : "600px",
            }}
          >
            Te avisaremos por WhatsApp cuando esté disponible para retirar en la
            agencia de Redpagos seleccionada.
          </p>
        </Box>

        <div className={classes.contentImageMobile}>
          <a
            href="https://italmundo.com.uy/"
            rel="noopener noreferrer"
            style={{
              width: "50%",
              maxWidth: "250px",
              maxHeight: "100%",
              paddingTop: "0.5rem",
              margin: mobile ? "1rem" : "3rem",
            }}
          >
            <img
              src={LogoItalmundo}
              alt="Home Mobile"
              style={{
                objectFit: "contain",
              }}
            />
          </a>
        </div>
      </Container>
    </>
  );
}

export default TarjetaPreAprobada;
